var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isSystemAdmin)?_c('div',{staticClass:"watermark-container",style:({ backgroundImage: `url(${_vm.svgUrl})` })}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }